import React, { useEffect, useState } from 'react';
import './Tooltip.scss';

interface ITooltip {
  message: string | React.ReactNode;
  isActive: boolean;
  clearIndex?: any;
  icon?: any;
  isSidebar?: boolean;
  appointmentClass?: boolean;
  wrapText?: boolean;
  additionalClass?: any;
}

const ToolTip = (props: ITooltip) => {
  const {
    message,
    isActive,
    clearIndex,
    icon,
    isSidebar,
    appointmentClass,
    wrapText,
    additionalClass,
  } = props;
  const [show, setShow] = useState(false);
  useEffect(() => {
    setShow(isActive);
    let id: any = null;
    if (clearIndex) {
      id = setTimeout(() => {
        setShow(false);
      }, 2000);
    }
    return () => {
      id && clearTimeout(id);
    };
  }, [isActive]);

  if (isActive) {
    return (
      <div
        data-testid="TooltipContainer"
        className={`${
          show
            ? appointmentClass
              ? 'tooltip-appointment active'
              : 'tooltip-container active'
            : 'tooltip-container'
        } ${isSidebar ? 'tooltip-sidebar' : ''} ${additionalClass}`}
      >
        <div className="tooltip">
          {icon && <p>{icon}</p>}
          <div data-testid="message" className={wrapText ? 'wrap' : ''}>
            <p>{message}</p>
          </div>
        </div>
      </div>
    );
  }
  return null;
};

export default React.memo(ToolTip);
